import { inject, Injectable, signal } from '@angular/core';
import { finalize } from 'rxjs';

import { Exception } from '../../shared/models/exception.model';
import { VehicleInformation } from '../../shared/models/vehicle-information.model';
import { VehicleService } from '../services/vehicle.service';

@Injectable()
export class VehicleStore {
  private readonly vehicleService = inject(VehicleService);

  readonly vehicle = signal<VehicleInformation | undefined>(undefined);
  readonly loading = signal(false);
  readonly exception = signal<Exception | undefined>(undefined);

  cleanStore(): void {
    this.vehicle.set(undefined);
    this.exception.set(undefined);
  }

  removeException(): void {
    this.exception.set(undefined);
  }

  getVehicleMasterData(vin: string): void {
    this.loading.set(true);
    this.vehicleService
      .getVehicleMasterData(vin)
      .pipe(finalize(() => this.loading.set(false)))
      .subscribe({
        next: (vehicle) => {
          this.vehicle.set(vehicle)
        },
        error: (err) => this.exception.set(new Exception(err.error)),
      });
  }
}
